import { makeResetMutation } from '@utils/reset-store'
import Vue from 'vue'
import moment from 'moment'
import {
  checkUniqueFinanceNull,
  checkConversionNull,
  checkComissionNull,
} from '@utils/Format'
import { sortByDate } from '@utils/Sort'
import { deepFreeze, freezeItems } from '@utils/Performance'
import { buildInitialState } from './state'

const RESET_FILTROS = (state) => {
  Object.keys(state.filtros).forEach((key) => {
    state.filtros[key] = []
  })
}

const RESET_FILTROS_OPCOES = (state) => {
  Object.keys(state.filtros_opcoes).forEach((key) => {
    state.filtros_opcoes[key] = []
  })
}

const CHANGE_FILTER = (state, payload) => {
  if (state.filtros[payload.attr].includes(payload.value)) {
    state.filtros[payload.attr] = state.filtros[payload.attr].filter((item) => {
      return item !== payload.value
    })
  } else {
    state.filtros[payload.attr].push(payload.value)
  }
}

const UPDATE_ALL_FILTERS = (state, payload) => {
  Object.keys(state.filtros_opcoes).forEach((key) => {
    state.filtros[key] = payload[key]
  })
}

const SET_LOADING_PROFISSIONAIS = (state, payload) => {
  state.profissionais.loading = payload
}

const SET_PROFISSIONAIS = (state, { value, metadata }) => {
  if (value && typeof value === 'object') {
    if (Array.isArray(value)) {
      state.profissionais.data = value.sort((a, b) =>
        (a.nome || a.id_profissional || '')
          .toString()
          .localeCompare(b.nome || b.id_profissional || '')
          .toString()
      )
    } else {
      state.profissionais.data = value
    }

    if (metadata) {
      state.profissionais.metadata = metadata
    }

    state.profissionais.lastUpdate = new Date()
  }
}

const ADD_PROFISSIONAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const old = state.profissionais.data.find((item) => {
      return item.id_profissional === payload.id_profissional
    })

    if (old) {
      Object.keys(payload).forEach((key) => {
        old[key] = payload[key]
      })
    } else {
      state.profissionais.data.push({ ...payload })
    }
  }
}

const REMOVE_PROFISSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.profissionais.data = state.profissionais.data.filter((item) => {
      return item.id_profissional !== payload.id_profissional
    })
  }
}

const SET_SEGMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.segmentos.data = payload.data
    state.segmentos.cores = payload.cores
    state.segmentos.lastUpdate = new Date()
  }
}

const SET_SEGMENTOS_LOADING = (state, payload) => {
  state.segmentos.loading = payload
}

const SET_EMPRESAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.empresas.data = payload
    // state.empresas.data.sort((a, b) => {
    //   return (a.nome_fantasia || '').localeCompare(b.nome_fantasia || '')
    // })
    state.empresas.lastUpdate = new Date()
  }
}

const SET_EMPRESAS_LOADING = (state, payload) => {
  state.empresas.loading = payload
}

const SET_HIERARQUIA_EMPRESAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.hierarquiaEmpresas.data = payload
    state.hierarquiaEmpresas.lastUpdate = new Date()
  }
}

const SET_HIERARQUIA_EMPRESA_LOADING = (state, payload) => {
  state.hierarquiaEmpresas.loading = payload
}

const SET_PLANOS_CARREIRA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.planosCarreira.data = payload
    state.planosCarreira.lastUpdate = new Date()
  }
}

const SET_PLANOS_CARREIRA_LOADING = (state, payload) => {
  state.planosCarreira.loading = payload
}

const SET_PLANO_CARREIRA_SELECIONADO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Lista para a escadinha
    state.planoSelecionado.data.dados_planos = payload.dados_planos || []
    // Dados do plano em si
    state.planoSelecionado.data.plano = payload.planos[0] || {}
    state.planoSelecionado.lastUpdate = new Date()

    if (
      state.planoSelecionado.data.dados_planos.length === 0 &&
      state.planoSelecionado.data.plano.id > 0
    ) {
      // Se nao tem nenhum nivel da escada cadastrado.
      const dadosPlanosDefault = []
      for (const segmento of state.segmentos.data) {
        for (const senior of state.senioridade.data) {
          dadosPlanosDefault.push({
            id_plano_de_carreira: state.planoSelecionado.data.plano.id,
            comissionamento: 0,
            desconto_comissionamento: 0,
            id_segmentacao: segmento.id,
            id_senoridade: senior.id,
            nivel: senior.nivel,
            nome_segmentacao: segmento.nome_segmentacao,
            nome_senoridade: senior.nome_senoridade,
            pl_max: segmento.pl_max,
            pl_min: segmento.pl_min,
            tipo_produto: 'Geral',
          })
        }
      }
      if (dadosPlanosDefault.length) {
        state.planoSelecionado.data.dados_planos = dadosPlanosDefault
      }
    }
  }
}

const SET_PLANO_CARREIRA_SELECIONADO_LOADING = (state, payload) => {
  state.planoSelecionado.loading = payload
}

const UPDATE_DADO_PLANO_CARREIRA_SELECIONADO = (state, payload) => {
  if (payload && payload.passo) {
    const passo = payload.passo[0] || payload.passo
    const old = state.planoSelecionado.data.dados_planos.find((item) => {
      return (
        item.id === payload.passo.id ||
        (item.id_plano_de_carreira === passo.id_plano_de_carreira &&
          item.id_segmentacao === passo.id_segmentacao &&
          item.id_senoridade === passo.id_senoridade)
      )
    })

    if (old) {
      old.id = passo.id
      old.comissionamento = passo.comissionamento
      old.desconto_comissionamento = passo.desconto_comissionamento
    } else {
      if (!passo.nome_segmentacao) {
        const seg = state.segmentos.data.find((item) => {
          return item.id === passo.id_segmentacao
        })
        if (seg) {
          passo.nome_segmentacao = seg.nome_segmentacao
        }
      }
      if (!passo.nome_senoridade) {
        const senior = state.senioridade.data.find((item) => {
          return item.id === passo.id_senoridade
        })
        if (senior) {
          passo.nome_senoridade = senior.nome_senoridade
        }
      }
      state.planoSelecionado.data.dados_planos.push({ ...passo })
    }
  }
}

const REMOVE_DADO_PLANO_CARREIRA = (state, payload) => {
  if (payload && payload.id) {
    state.planoSelecionado.data.dados_planos =
      state.planoSelecionado.data.dados_planos.filter((item) => {
        return item.id !== payload.id
      })
  }
}

const SET_DADO_PLANO_CARREIRA_LOADING = (state, payload) => {
  if (payload && payload.id) {
    const passo = state.planoSelecionado.data.dados_planos.find((item) => {
      return item.id === payload.id
    })

    if (passo) {
      const v = Vue
      Vue.set(passo, 'loading', payload.loading)
      console.log(v)
      // passo.loading = payload.loading
    }
  }
}

const SET_QUADRANTES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.faixaCorteQuadrantes.data = { ...payload }
    state.faixaCorteQuadrantes.lastUpdate = new Date()
  }
}

const SET_QUADRANTES_LOADING = (state, payload) => {
  state.faixaCorteQuadrantes.loading = payload
}

const SET_SENIORIDADE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.senioridade.data = payload.sort((a, b) => {
      return a.nivel > b.nivel ? 1 : -1
    })
    state.senioridade.lastUpdate = new Date()
  }
}

const SET_SENIORIDADE_LOADING = (state, payload) => {
  state.senioridade.loading = payload
}

const ADD_SENIORIDADE = (state, payload) => {
  if (payload && typeof payload === 'object' && payload.id > 0) {
    let old = state.senioridade.data.find((item) => {
      return item.id === payload.id
    })

    if (old) {
      old.data_atualizacao = payload.data_atualizacao
      old.data_registro = payload.data_registro
      old.id = payload.id
      old.id_escritorio = payload.id_escritorio
      old.nivel = payload.nivel
      old.nome_senoridade = payload.nome_senoridade
    } else {
      state.senioridade.data.push({ ...payload })
    }
  }
}

const REMOVE_SENIORIDADE = (state, payload) => {
  if (payload && typeof payload === 'object' && payload.id > 0) {
    state.senioridade.data = state.senioridade.data.filter((item) => {
      return item.id !== payload.id
    })
  }
}

const SET_DADOS_GERAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    Object.entries(payload).forEach((item) => {
      // Congela o VALOR (read-only para display); o container-mapa continua
      // mutável porque acumula chaves entre SETs [CU-86ajnmrzf]
      state.dadosGerais.data[item[0]] = deepFreeze(item[1])
    })
    state.dadosGerais.lastUpdate = new Date()
  }
}

const SET_DADOS_GERAIS_LOADING = (state, payload) => {
  state.dadosGerais.loading = payload
}

const SET_DOCUMENTOS = (state, payload) => {
  const { id_profissional, data } = payload
  if (id_profissional > 0 && data.length > 0) {
    if (state.documentos.data[id_profissional]) {
      data.forEach((item) => {
        const old = state.documentos.data[id_profissional].data.find((doc) => {
          return doc.id === item.id
        })

        if (old) {
          Object.keys(item).forEach((key) => {
            old[key] = item[key]
          })
        } else {
          state.documentos.data[id_profissional].data.push({ ...item })
        }
      })

      state.documentos.data[id_profissional].lastUpdate = new Date()
    } else {
      state.documentos.data[id_profissional] = {
        loading: false,
        lastUpdate: new Date(),
        data: [...data],
      }
    }
  }
}

const SET_DOCUMENTOS_LOADING = (state, payload) => {
  const { id_profissional, loading } = payload
  if (id_profissional > 0) {
    if (state.documentos.data[id_profissional]) {
      state.documentos.data[id_profissional].loading = loading
    } else {
      state.documentos.data[id_profissional] = {
        loading,
        lastUpdate: null,
        data: [],
      }
    }
  }
}

const REMOVE_DOCUMENTOS = (state, payload) => {
  const { id, id_profissional } = payload
  if (id > 0 && id_profissional > 0) {
    state.documentos.data[id_profissional].data = state.documentos.data[
      id_profissional
    ].data.filter((item) => {
      return item.id !== id
    })
  }
}

const SET_FINANCEIRO_UNICO = (state, payload) => {
  let hasZeroValue = false
  if (payload && typeof payload === 'object') {
    payload = payload.map((p) => {
      p.custo_fixo_em_porcentagem_receita = Math.round10(
        p.custo_fixo_em_porcentagem_receita * 100,
        -2
      )
      p.bonificacao = Math.round10(p.bonificacao * 100, -2)
      p.roa_liquido = Math.round10(p.roa_liquido * 100, -2)
      return p
    })
    state.tiposProfissionais.data.forEach((item) => {
      const dados = payload.filter((p) => {
        if (checkUniqueFinanceNull(p)) {
          hasZeroValue = true
        }
        return p.id_tipo_profissional === item.id
      })
      state.financeiroUnico.data[item.id] = freezeItems(dados || [])
    })
    state.financeiroUnico.hasZeroValue = hasZeroValue
    state.financeiroUnico.lastUpdate = new Date()
  }
}

const SET_FINANCEIRO_UNICO_LOADING = (state, payload) => {
  state.financeiroUnico.loading = payload
}

const SET_FINANCEIRO_CONVERSAO = (state, payload) => {
  const attrDecimalFormat = [
    'conversao_ano_1',
    'conversao_ano_2',
    'conversao_ano_3',
    'conversao_anos_subsequentes',
  ]
  let hasZeroValue = false
  if (payload && typeof payload === 'object') {
    payload = payload.map((p) => {
      attrDecimalFormat.forEach((key) => {
        p[key] = Math.round10(p[key] * 100, -2)
      })

      return p
    })
    state.tiposProfissionais.data.forEach((item) => {
      const dados = payload.filter((p) => {
        if (checkConversionNull(p)) {
          hasZeroValue = true
        }
        return p.id_tipo_profissional === item.id
      })
      state.financeiroConversao.data[item.id] = freezeItems(dados || [])
    })
    state.financeiroConversao.hasZeroValue = hasZeroValue
    state.financeiroConversao.lastUpdate = new Date()
  }
}

const SET_FINANCEIRO_CONVERSAO_LOADING = (state, payload) => {
  state.financeiroConversao.loading = payload
}

const SET_FINANCEIRO_COMISSAO = (state, payload) => {
  const attrDecimalFormat = [
    'comissao_ano_1',
    'comissao_ano_2',
    'comissao_ano_3',
    'comissao_anos_subsequentes',
  ]
  let hasZeroValue = false
  if (payload && typeof payload === 'object') {
    payload = payload.map((p) => {
      attrDecimalFormat.forEach((key) => {
        p[key] = Math.round10(p[key] * 100, -2)
      })

      return p
    })
    state.tiposProfissionais.data.forEach((item) => {
      const dados = payload.filter((p) => {
        if (checkComissionNull(p)) {
          hasZeroValue = true
        }
        return p.id_tipo_profissional === item.id
      })
      state.financeiroComissao.data[item.id] = freezeItems(dados || [])
    })
    state.financeiroComissao.hasZeroValue = hasZeroValue
    state.financeiroComissao.lastUpdate = new Date()
  }
}

const SET_FINANCEIRO_COMISSAO_LOADING = (state, payload) => {
  state.financeiroComissao.loading = payload
}

const SET_PARAMETROS_REGIOES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.parametrosRegioes.data = payload.value.map((item) => {
      return item.regiao
    })
    state.parametrosRegioes.opcoes = payload.regions || []
    state.parametrosRegioes.lastUpdate = new Date()
  }
}

const SET_PARAMETROS_REGIOES_LOADING = (state, payload) => {
  state.parametrosRegioes.loading = payload
}

const SET_PARAMETROS_SEGMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    payload.forEach((item) => {
      state.parametrosSegmentos.data[item.id_segmentacao] = Math.round10(
        item.participacao * 100,
        -2
      )
    })
    state.parametrosSegmentos.lastUpdate = new Date()
  }
}

const SET_PARAMETROS_SEGMENTOS_LOADING = (state, payload) => {
  state.parametrosSegmentos.loading = payload
}

const SET_PARAMETROS_CONTRATACOES = (state, payload) => {
  const maskReferencia = 'DD/MM/YYYY'

  if (payload && typeof payload === 'object') {
    payload.forEach((item) => {
      if (item.data_referencia) {
        const ano = moment(item.data_referencia, maskReferencia).format('YYYY')
        // ANO: {id_seg: {id_senioridade: {id_tipo_profissional: qtd}}}
        if (!state.parametrosContratacoes.data[ano]) {
          state.parametrosContratacoes.data[ano] = {}
        }
        if (!state.parametrosContratacoes.data[ano][item.id_segmentacao]) {
          state.parametrosContratacoes.data[ano][item.id_segmentacao] = {}
        }
        if (
          !state.parametrosContratacoes.data[ano][item.id_segmentacao][
            item.id_senioridade
          ]
        ) {
          state.parametrosContratacoes.data[ano][item.id_segmentacao][
            item.id_senioridade
          ] = {}
        }
        state.parametrosContratacoes.data[ano][item.id_segmentacao][
          item.id_senioridade
        ][item.id_tipo_profissional] = item.numero_contratacoes
      }
    })

    state.parametrosContratacoes.lastUpdate = new Date()
  }
}

const PREENCHER_IDS_PARAMETROS_CONTRATACOES = (state, payload) => {
  const { anos } = payload
  anos.forEach((ano) => {
    if (!state.parametrosContratacoes.data[ano]) {
      state.parametrosContratacoes.data[ano] = {}
    }
    state.segmentos.data.forEach((seg) => {
      if (!state.parametrosContratacoes.data[ano][seg.id]) {
        state.parametrosContratacoes.data[ano][seg.id] = {}
      }
      state.senioridade.data.forEach((senior) => {
        if (!state.parametrosContratacoes.data[ano][seg.id][senior.id]) {
          state.parametrosContratacoes.data[ano][seg.id][senior.id] = {}
        }
      })
    })
  })
}

const SET_PARAMETROS_CONTRATACOES_LOADING = (state, payload) => {
  state.parametrosContratacoes.loading = payload
}

const SET_PARAMETROS_INCENTIVOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    payload.forEach((item) => {
      if (item.data_referencia) {
        if (!state.parametrosIncentivos.data) {
          state.parametrosIncentivos.data = {}
        }
        if (state.parametrosIncentivos.data[item.data_referencia]) {
          Object.keys(item).forEach((key) => {
            state.parametrosIncentivos.data[item.data_referencia][key] =
              item[key]
          })
        } else {
          state.parametrosIncentivos.data[item.data_referencia] = { ...item }
        }
      }
    })

    state.parametrosIncentivos.lastUpdate = new Date()
  }
}

const SET_PARAMETROS_INCENTIVOS_LOADING = (state, payload) => {
  state.parametrosIncentivos.loading = payload
}

const SET_PARAMETROS_METAS_ESCRITORIO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const aux = {}
    payload.forEach((item) => {
      // Formatando para garantir que eh o final do ano
      const data = moment(item.data_referencia, 'DD/MM/YYYY')
        .endOf('year')
        .format('DD/MM/YYYY')
      aux[data] = (aux[data] || 0) + item.auc
    })

    state.parametrosMetasEscritorio.data = { ...aux }

    state.parametrosMetasEscritorio.lastUpdate = new Date()
  }
}

const SET_PARAMETROS_METAS_ESCRITORIO_LOADING = (state, payload) => {
  state.parametrosMetasEscritorio.loading = payload
}

const SET_PARAMETROS_METAS_PROFISSIONAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // {id_profissional: {ano1, ano2, ano3, media}}

    const ano = new Date().getFullYear()
    const anos = [ano, ano + 1, ano + 2]
    const [ano1, ano2, ano3] = anos

    Object.entries(payload).forEach((item) => {
      const aux = {}
      aux.id_profissional = item[0]

      // Calcular os 3 anos iniciais
      item[1].forEach((v) => {
        if (v.data_referencia && typeof v.data_referencia === 'string') {
          if (v.data_referencia.includes(`/${ano1}`)) {
            aux['ano1'] = v.auc
          } else if (v.data_referencia.includes(`/${ano2}`)) {
            aux['ano2'] = v.auc
          } else if (v.data_referencia.includes(`/${ano3}`)) {
            aux['ano3'] = v.auc
          }
        }
      })

      // Calcular media
      const ultimo = item[1][item[1].length - 1]
      const penultimo = item[1][item[1].length - 2]
      aux.media = ultimo.auc - penultimo.auc

      state.parametrosMetasProfissionais.data[item[0]] = { ...aux }
    })

    state.parametrosMetasProfissionais.lista = JSON.parse(
      JSON.stringify(Object.values(payload).flat())
    )

    state.parametrosMetasProfissionais.lastUpdate = new Date()
  }
}

const SET_PARAMETROS_METAS_PROFISSIONAIS_LOADING = (state, payload) => {
  state.parametrosMetasProfissionais.loading = payload
}

const SET_PROJECAO_AUC = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const { status, value, message } = payload
    // Payload grande (DRE/projeção) read-only para display — congelar evita
    // o defineReactive recursivo do Vue 2 [CU-86ajnmrzf]
    state.projecaoAuC.data = deepFreeze({ ...value })
    state.projecaoAuC.message = message
    state.projecaoAuC.status = status

    state.projecaoAuC.lastUpdate = new Date()
  }
}

const SET_PROJECAO_AUC_LOADING = (state, payload) => {
  state.projecaoAuC.loading = payload
}

const SET_HISTORICO_AUC = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Séries históricas grandes, read-only para display [CU-86ajnmrzf]
    state.historicoAuC.data.office = deepFreeze(payload.office || {})
    if (payload.summary) {
      state.historicoAuC.data.professional = deepFreeze(
        payload.summary.professional || {}
      )
    } else {
      state.historicoAuC.data.professional = {}
    }
    state.historicoAuC.lastUpdate = new Date()
  }
}

const SET_HISTORICO_AUC_LOADING = (state, payload) => {
  state.historicoAuC.loading = payload
}

const SET_HISTORICO_AUC_PROFISSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object' && payload.in_) {
    const id = payload.in_.id_profissional_responsavel[0]

    // Histórico por profissional, read-only; o container-mapa acumula por id
    // então congelamos só o valor [CU-86ajnmrzf]
    state.historicoAuCProfissional.data[id] = deepFreeze(
      JSON.parse(JSON.stringify(payload.value))
    )

    state.historicoAuCProfissional.lastUpdate = new Date()
  }
}

const SET_HISTORICO_AUC_PROFISSIONAL_LOADING = (state, payload) => {
  state.historicoAuCProfissional.loading = payload
}

const SET_CONTRATACOES_EFETIVADAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const sum = {}
    const clusters = {}
    payload.forEach((item) => {
      const old = state.contratacoesEfetivadas.data.find((c) => {
        return c.id === item.id
      })
      if (old) {
        Object.keys(item).forEach((key) => {
          old[key] = item[key]
        })
      } else {
        state.contratacoesEfetivadas.data.push(item)
      }

      if (item.data_contratacao) {
        // Contabilizar quantas contratações por ano
        const ano = item.data_contratacao.split('/').reverse()[0]
        if (!sum[item.id_tipo_profissional]) {
          sum[item.id_tipo_profissional] = {}
        }
        sum[item.id_tipo_profissional][ano] =
          (sum[item.id_tipo_profissional][ano] || 0) + 1

        if (!clusters[item.id_tipo_profissional]) {
          clusters[item.id_tipo_profissional] = {}
        }
        if (!clusters[item.id_tipo_profissional][ano]) {
          clusters[item.id_tipo_profissional][ano] = {}
        }
        clusters[item.id_tipo_profissional][ano][item.id_segmentacao] =
          (clusters[item.id_tipo_profissional][ano][item.id_segmentacao] || 0) +
          1
      }
    })

    state.tiposProfissionais.data.forEach((tipo) => {
      state.contratacoesEfetivadas.sum[tipo.id] = {
        ...state.contratacoesEfetivadas.sum[tipo.id],
        ...sum[tipo.id],
      }
      state.contratacoesEfetivadas.clusters[tipo.id] = {
        ...state.contratacoesEfetivadas.clusters[tipo.id],
        ...clusters[tipo.id],
      }
    })
    state.contratacoesEfetivadas.lastUpdate = new Date()
  }
}

const SET_CONTRATACOES_EFETIVADAS_LOADING = (state, payload) => {
  state.contratacoesEfetivadas.loading = payload
}

const REMOVE_CONTRATACAO_EFETIVADA = (state, payload) => {
  state.contratacoesEfetivadas.data = state.contratacoesEfetivadas.data.filter(
    (item) => {
      return item.id !== payload.id
    }
  )
}

const SET_PARAMETROS_ADICIONAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    Object.keys(payload).forEach((key) => {
      state.parametrosAdicionais.data[key] = payload[key]
    })
    state.parametrosAdicionais.lastUpdate = new Date()
  }
}

const SET_PARAMETROS_ADICIONAIS_LOADING = (state, payload) => {
  state.parametrosAdicionais.loading = payload
}

const SET_CUSTOS_ADICIONAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.custosAdicionais.data = payload
    state.custosAdicionais.lastUpdate = new Date()
  }
}

const SET_CUSTOS_ADICIONAIS_LOADING = (state, payload) => {
  state.custosAdicionais.loading = payload
}

const SET_HISTORICO_PLANILHAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.historicoPlanilhas.data = payload

    payload.forEach((item) => {
      if (!state.historicoPlanilhas.dicLastByType[item.file_name]) {
        item.data_atualizacao = item.data_atualizacao.split(' ')[0]
        state.historicoPlanilhas.dicLastByType[item.file_name] = { ...item }
      }
    })

    // Congelar os itens SÓ no final: o forEach acima ainda muta
    // data_atualizacao de alguns items [CU-86ajnmrzf]
    freezeItems(state.historicoPlanilhas.data)

    state.historicoPlanilhas.lastUpdate = new Date()
  }
}

const SET_HISTORICO_PLANILHAS_LOADING = (state, payload) => {
  state.historicoPlanilhas.loading = payload
}

export const SET_MULTIPLOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.multiplos.data = payload
    state.multiplos.lastUpdate = new Date()
  }
}

export const SET_MULTIPLOS_LOADING = (state, payload) => {
  state.multiplos.loading = payload
}

const SET_EXTERN_AGENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.externAgents.data = payload
    state.externAgents.lastUpdate = new Date()
  }
}
const ADD_EXTERN_AGENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const old = state.externAgents.data.find((item) => {
      return item.id === payload.id
    })

    if (old) {
      Object.assign(old, payload)
    } else {
      state.externAgents.data.push(payload)
    }
    state.externAgents.lastUpdate = new Date()
  }
}
const SET_EXTERN_AGENTS_LOADING = (state, payload) => {
  state.externAgents.loading = payload
}

const SET_PARTNERSHIPS_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.partnershipsProfessionals.data = payload
    state.partnershipsProfessionals.lastUpdate = new Date()
  }
}
const ADD_PARTNERSHIPS_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    payload.forEach((partnership) => {
      const old = state.partnershipsProfessionals.data.find((item) => {
        return (
          item.id_pj === partnership.id_pj &&
          item.id_profissional === partnership.id_profissional
        )
      })

      if (old) {
        Object.assign(old, partnership)
      } else {
        state.partnershipsProfessionals.data.push(partnership)
      }
    })

    state.partnershipsProfessionals.lastUpdate = new Date()
  }
}
const SET_PARTNERSHIPS_PROFESSIONALS_LOADING = (state, payload) => {
  state.partnershipsProfessionals.loading = payload
}

const SET_PARTNERSHIPS_EXTERN_AGENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.partnershipsExternAgents.data = payload
    state.partnershipsExternAgents.lastUpdate = new Date()
  }
}
const ADD_PARTNERSHIPS_EXTERN_AGENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    payload.forEach((partnership) => {
      const old = state.partnershipsExternAgents.data.find((item) => {
        return item.id === partnership.id
      })

      if (old) {
        Object.assign(old, partnership)
      } else {
        state.partnershipsExternAgents.data.push(partnership)
      }
    })

    state.partnershipsExternAgents.lastUpdate = new Date()
  }
}
const SET_PARTNERSHIPS_EXTERN_AGENTS_LOADING = (state, payload) => {
  state.partnershipsExternAgents.loading = payload
}

export const SET_FILIAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.filiais.data = [...payload]
    state.filiais.lastUpdate = new Date()
  }
}

export const ADD_FILIAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    payload.forEach((filial) => {
      const old = state.filiais.data.find((item) => {
        return item.id === filial.id
      })

      if (old) {
        Object.assign(old, filial)
      } else {
        state.filiais.data.push(filial)
      }
    })

    state.filiais.lastUpdate = new Date()
  }
}

export const SET_FILIAIS_LOADING = (state, payload) => {
  state.filiais.loading = payload
}

export const SET_PROJECAO_AUC_TEAM = (state, payload) => {
  if (payload && typeof payload === 'object') {
    // Replace-total, read-only para display; consumidor (expansao-visao-global)
    // clona antes de mutar [CU-86ajnmrzf]
    state.projecaoAucTeam.data = deepFreeze(payload)
    state.projecaoAucTeam.lastUpdate = new Date()
  }
}
export const SET_PROJECAO_AUC_TEAM_LOADING = (state, payload) => {
  state.projecaoAucTeam.loading = payload
}

export const SET_DATA_ROOM_FILES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dataRoomFiles.data = sortByDate({
      items: payload,
      key: 'data_referencia',
    })
    state.dataRoomFiles.lastUpdate = new Date()
  }
}
export const ADD_DATA_ROOM_FILES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.dataRoomFiles.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.dataRoomFiles.data.push(data)
      }
    })

    state.dataRoomFiles.data = sortByDate({
      items: state.dataRoomFiles.data,
      key: 'data_referencia',
    })
  }
}
export const SET_DATA_ROOM_FILES_LOADING = (state, payload) => {
  state.dataRoomFiles.loading = payload
}
export const SET_DATA_ROOM_OPTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dataRoomOptions.data = payload
    state.dataRoomOptions.lastUpdate = new Date()
  }
}
export const SET_DATA_ROOM_OPTIONS_LOADING = (state, payload) => {
  state.dataRoomOptions.loading = payload
}

export const SET_OPTION_FILTER_AUC = (state, payload) => {
  state.optionFilter.auc = payload
}

export const SET_OPTION_FILTER_ACTIVE = (state, payload) => {
  state.optionFilter.active = payload
}

export const SET_OPTION_REQUIRED_FILE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.optionsRequiredFiles.data = payload
    state.optionsRequiredFiles.lastUpdate = new Date()
  }
}

export const SET_DATA_ROOM_SELECTED_YEAR = (state, payload) => {
  state.dataRoomSelectedYear = payload
}

export {
  RESET_FILTROS,
  RESET_FILTROS_OPCOES,
  CHANGE_FILTER,
  UPDATE_ALL_FILTERS,
  SET_LOADING_PROFISSIONAIS,
  SET_PROFISSIONAIS,
  ADD_PROFISSIONAIS,
  REMOVE_PROFISSIONAL,
  SET_SEGMENTOS,
  SET_SEGMENTOS_LOADING,
  SET_EMPRESAS,
  SET_EMPRESAS_LOADING,
  SET_HIERARQUIA_EMPRESAS,
  SET_HIERARQUIA_EMPRESA_LOADING,
  SET_PLANOS_CARREIRA,
  SET_PLANOS_CARREIRA_LOADING,
  SET_PLANO_CARREIRA_SELECIONADO,
  SET_PLANO_CARREIRA_SELECIONADO_LOADING,
  UPDATE_DADO_PLANO_CARREIRA_SELECIONADO,
  REMOVE_DADO_PLANO_CARREIRA,
  SET_DADO_PLANO_CARREIRA_LOADING,
  SET_QUADRANTES,
  SET_QUADRANTES_LOADING,
  SET_SENIORIDADE,
  SET_SENIORIDADE_LOADING,
  ADD_SENIORIDADE,
  REMOVE_SENIORIDADE,
  SET_DADOS_GERAIS,
  SET_DADOS_GERAIS_LOADING,
  SET_DOCUMENTOS,
  SET_DOCUMENTOS_LOADING,
  REMOVE_DOCUMENTOS,
  SET_FINANCEIRO_UNICO,
  SET_FINANCEIRO_UNICO_LOADING,
  SET_FINANCEIRO_CONVERSAO,
  SET_FINANCEIRO_CONVERSAO_LOADING,
  SET_FINANCEIRO_COMISSAO,
  SET_FINANCEIRO_COMISSAO_LOADING,
  SET_PARAMETROS_REGIOES,
  SET_PARAMETROS_REGIOES_LOADING,
  SET_PARAMETROS_SEGMENTOS,
  SET_PARAMETROS_SEGMENTOS_LOADING,
  SET_PARAMETROS_CONTRATACOES,
  SET_PARAMETROS_CONTRATACOES_LOADING,
  PREENCHER_IDS_PARAMETROS_CONTRATACOES,
  SET_PARAMETROS_INCENTIVOS,
  SET_PARAMETROS_INCENTIVOS_LOADING,
  SET_PARAMETROS_METAS_ESCRITORIO,
  SET_PARAMETROS_METAS_ESCRITORIO_LOADING,
  SET_PARAMETROS_METAS_PROFISSIONAIS,
  SET_PARAMETROS_METAS_PROFISSIONAIS_LOADING,
  SET_PROJECAO_AUC,
  SET_PROJECAO_AUC_LOADING,
  SET_HISTORICO_AUC,
  SET_HISTORICO_AUC_LOADING,
  SET_HISTORICO_AUC_PROFISSIONAL,
  SET_HISTORICO_AUC_PROFISSIONAL_LOADING,
  SET_CONTRATACOES_EFETIVADAS,
  SET_CONTRATACOES_EFETIVADAS_LOADING,
  REMOVE_CONTRATACAO_EFETIVADA,
  SET_PARAMETROS_ADICIONAIS,
  SET_PARAMETROS_ADICIONAIS_LOADING,
  SET_CUSTOS_ADICIONAIS,
  SET_CUSTOS_ADICIONAIS_LOADING,
  SET_HISTORICO_PLANILHAS,
  SET_HISTORICO_PLANILHAS_LOADING,
  SET_EXTERN_AGENTS,
  ADD_EXTERN_AGENTS,
  SET_EXTERN_AGENTS_LOADING,
  SET_PARTNERSHIPS_PROFESSIONALS,
  ADD_PARTNERSHIPS_PROFESSIONALS,
  SET_PARTNERSHIPS_PROFESSIONALS_LOADING,
  SET_PARTNERSHIPS_EXTERN_AGENTS,
  ADD_PARTNERSHIPS_EXTERN_AGENTS,
  SET_PARTNERSHIPS_EXTERN_AGENTS_LOADING,
}

// RESET: restaura o state inicial (libera dados de cliente/escritório retidos
// entre trocas de perfil/escritório in-SPA). Reatribui cada chave a partir do
// factory — reusa a reatividade existente. [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)
